import { Card, Col, Row, Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useClinicStore } from './store';
import { isEmpty } from 'lodash';
import { EditOutlined, PicLeftOutlined } from '@ant-design/icons';
import PaginationDiv from 'modules/pagination/PaginationDiv';

const AllClinics = ({ setActiveTab, setClincId }) => {
  const { getClinics, AllclinicData, getClnicDetails, clinicsAllData } = useClinicStore();
  const [allClinics, setAllClinics] = useState([]);
  const [page, newPage] = useState(1);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedClinicId, setSelectedClinicId] = useState(null);

  useEffect(() => {
    getClinics(page);
  }, [page]);

  useEffect(() => {
    setAllClinics(AllclinicData?.clinics);
  }, [AllclinicData]);

  const handleEditClinic = (clinicId) => {
    setClincId(clinicId);
    setActiveTab('editClinic');
  };

  const handleShowDetails = (clinicId) => {
    setSelectedClinicId(clinicId);
    getClnicDetails(clinicId);
    setViewModalVisible(true);
  };

  return (
    <div style={{ padding: '20px' }}>
      {!isEmpty(allClinics) && (
        <Row gutter={[16, 16]}>
          {allClinics?.map((clinic) => (
            <Col key={clinic._id} xs={24} sm={12} md={8} lg={6} xl={4}>
              <Card
                title={clinic.clinic_name}
                style={{ height: '100%' }}
                actions={[
                  <PicLeftOutlined key="view" onClick={() => handleShowDetails(clinic.clinic_id)} />,
                  <EditOutlined key="edit" onClick={() => handleEditClinic(clinic.clinic_id)} />,
                ]}
              >
                <p>{clinic.address}</p>
                <p>{clinic.city}</p>
                <p>{clinic.locality}</p>
                <p>{clinic.pincode}</p>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <div>
        <PaginationDiv
          newPage={newPage}
          paginationData={{
            pageCount: AllclinicData?.pagination?.totalPages || 1,
            page: page,
          }}
        />
      </div>
      <Modal
        title="Clinic Details"
        visible={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setViewModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        {selectedClinicId && clinicsAllData && (
          <div>
            <p>
              <strong>Clinic Name:</strong> {clinicsAllData.clinic_name}
            </p>
            <p>
              <strong>Address:</strong> {clinicsAllData.address}
            </p>
            <p>
              <strong>City:</strong> {clinicsAllData.city}
            </p>
            <p>
              <strong>Locality:</strong> {clinicsAllData.locality}
            </p>
            <p>
              <strong>Pincode:</strong> {clinicsAllData.pincode}
            </p>
            <p>
              <strong>Clinic ID:</strong> {clinicsAllData.clinic_id}
            </p>
            <p>
              <strong>Clinic Persons:</strong>
            </p>
            <ul>
              {clinicsAllData.clinic_persons?.map((person) => (
                <li key={person._id}>
                  <strong>Name:</strong> {person.name},
                  <strong> Phone Number:</strong> {person.phone_number},
                  <strong> Email:</strong> {person.email},
                  <strong> Type:</strong> {person.type}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AllClinics;
